/********************************************************************
 * Project: WDCK（2021）
 * Class: RsvDateTimeDTO
 * ----------------------------------------
 * <summary>
 * RsvDateTimeDTO
 * </summary>
 * <history>
 *      ThaiTV     2022/01/05      Create
 * </history>
 ********************************************************************/
 export class RsvDateTimeDTO {
    RsvYMD: string;
    RsvTime: string;
}
